/* ============================================================
   PINSEEKER — PS INTERACTIONS v3.0
   Source: dev-homepage.md (ATC State Machine) +
           PS_Website_Style/ps-homepage-prototype.html (all JS)
   ============================================================ */

/* ── SCROLL REVEAL ── */
(function () {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('ps-reveal--visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.04, rootMargin: '0px 0px -20px 0px' });

  function observeRevealEls(root) {
    (root || document).querySelectorAll('.ps-reveal:not(.ps-reveal--visible)').forEach(el => observer.observe(el));
  }

  // IntersectionObserver callbacks fire in the same task as .observe(), so
  // a single rAF isn't enough — the browser never commits an opacity:0 paint
  // before the class is added. setTimeout pushes observation into a new task,
  // guaranteeing at least one committed frame at opacity:0.
  setTimeout(function () { observeRevealEls(); }, 50);

  // Re-observe when a section is added or reloaded in the Shopify theme editor
  document.addEventListener('shopify:section:load', function (e) {
    observeRevealEls(e.target);
  });
})();

/* ── MOBILE NAV ── */
(function () {
  const hamburger = document.getElementById('ps-hamburger');
  const mobileNav = document.getElementById('ps-mobile-nav');
  if (!hamburger || !mobileNav) return;

  function closeMobileNav() {
    hamburger.classList.remove('is-open');
    mobileNav.classList.remove('is-open');
    hamburger.setAttribute('aria-expanded', 'false');
  }

  hamburger.addEventListener('click', () => {
    const isOpen = mobileNav.classList.toggle('is-open');
    hamburger.classList.toggle('is-open');
    hamburger.setAttribute('aria-expanded', String(isOpen));
  });

  document.addEventListener('click', (e) => {
    if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
      closeMobileNav();
    }
  });

  // Close on nav link click
  mobileNav.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', closeMobileNav);
  });
})();

/* ── ATC STATE MACHINE (dev-homepage.md Section 04) ── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.ps-atc-form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('.ps-btn--atc');
      if (!btn) return;
      const formData = new FormData(form);

      if (btn.classList.contains('is-locking') || btn.classList.contains('is-acquired')) return;

      btn.classList.add('is-locking');
      btn.textContent = 'LOCKING TARGET...';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          btn.classList.remove('is-locking');
          btn.classList.add('is-acquired');
          btn.textContent = 'TARGET ACQUIRED';
          window.dispatchEvent(new CustomEvent('ps:cart:updated'));
        } else {
          btn.classList.remove('is-locking');
          btn.textContent = 'MISSION ABORTED';
          setTimeout(() => { btn.textContent = 'ADD TO BAG'; }, 2500);
        }
      } catch (error) {
        btn.classList.remove('is-locking');
        btn.textContent = 'MISSION ABORTED';
        setTimeout(() => { btn.textContent = 'ADD TO BAG'; }, 2500);
      }

      setTimeout(() => {
        btn.classList.remove('is-acquired');
        btn.textContent = 'ADD TO BAG';
      }, 2500);
    });
  });
});

/* ── EMAIL SUBMIT ── */
(function () {
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!form.classList.contains('ps-email__form')) return;
    e.preventDefault();
    const btn = form.querySelector('.ps-email__btn');
    const input = form.querySelector('.ps-email__input');
    if (!btn || !input) return;
    btn.textContent = 'TRANSMISSION SENT';
    btn.style.background = 'rgba(0,255,65,0.15)';
    btn.style.color = '#00FF41';
    input.value = '';
    input.placeholder = 'COMMS CONFIRMED. STANDING BY.';
    setTimeout(() => {
      btn.textContent = 'CONFIRM COMMS';
      btn.style.background = '';
      btn.style.color = '';
      input.placeholder = 'ENTER EMAIL // AWAITING COMMS...';
    }, 3000);
  });
})();

/* ── CARD QUICK ADD (PS_V4 session 1) ──────────────────────────────────────
   The plus on a product card (snippets/ps-product-card.liquid, quick_add: true).
   ONE delegated listener for every card on the page, so a rail or grid that a
   later session adds, or the theme editor reloads, needs no wiring of its own.
   It posts the card's variant to /cart/add.js, then dispatches ps:cart:updated,
   which is exactly what the product page's Add to bag does: the header rewrites
   .ps-cart-count and the drawer (snippets/ps-cart-drawer.liquid) opens itself
   and re-reads /cart.js. The button is disabled while the request runs, so a
   second press cannot add a second unit. A failure says so in the card. */
(function () {
  var MSG = 'Could not add. Try again.';

  /* PS_V4 session 1b: the caption-strip lift that lived here is gone with the
     strip (the descriptor is now the title's second line, under the tile). */

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-ps-qadd-btn]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    var box = btn.closest('[data-ps-qadd]');
    var err = box ? box.querySelector('[data-ps-qadd-err]') : null;
    if (!id) {
      if (err) err.textContent = MSG;
      return;
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (err) err.textContent = '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add ' + r.status);
        return r.json();
      })
      .then(function () {
        window.dispatchEvent(new CustomEvent('ps:cart:updated'));
      })
      .catch(function () {
        if (err) err.textContent = MSG;
      })
      .then(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  });
})();

/* CART COUNT UPDATE: removed 12 Sep 2026 (Codex review). sections/header.liquid
   owns the ps:cart:updated count refresh (and the pill's aria-label); this copy made
   a second /cart.js request on every cart change. */

/* ── INSTAFEED ALT TEXT (PS_V3 session 6, fix 17) ──────────────────────────
   The Instafeed app injects its own markup after this script runs, and its
   hover-overlay placeholders arrive as <img alt=""> outside any aria-hidden
   subtree: 12 of them on the homepage, measured in a browser walk at 1440.
   site_recheck reports 0 because it reads the SERVER html, where the app's
   images do not exist yet. A MutationObserver is therefore the only place the
   theme can reach them.

   The post tiles already carry the caption in their own alt; those are left
   alone. Anything else the app injects is a decorative duplicate of the link
   around it, so it is marked aria-hidden AND given a non-empty alt, which
   keeps it out of the accessibility tree and out of an empty-alt audit.
   Not in theme.liquid: app markup is a theme behaviour, not a layout. */
(function () {
  if (!('MutationObserver' in window)) return;
  var FALLBACK = 'PINSEEKER on Instagram';

  function captionFor(img) {
    var item = img.closest && img.closest('.instafeed-new-layout-item, [class*="instafeed"][class*="item"]');
    if (item) {
      var sib = item.querySelector('img[alt]:not([alt=""])');
      if (sib && sib !== img) return sib.getAttribute('alt');
      var link = item.matches('a') ? item : item.querySelector('a');
      if (link) {
        var lab = link.getAttribute('aria-label') || link.getAttribute('title');
        if (lab) return lab;
      }
    }
    return null;
  }

  function label(root) {
    var imgs = (root || document).querySelectorAll
      ? (root || document).querySelectorAll('img.instafeed-lazy-image, [class*="instafeed"] img')
      : [];
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.getAttribute('alt')) continue;
      /* The hover overlay duplicates the tile's own link, so it is
         decorative even though the app leaves it in the a11y tree. */
      var deco = img.closest && img.closest('.instafeed-hover-icon, [class*="hover-icon"], [class*="instafeed"][class*="icon"]');
      var cap = deco ? null : captionFor(img);
      if (cap) {
        img.setAttribute('alt', cap);
      } else {
        /* A decorative overlay icon: hide it from assistive tech, and still
           give it text so no image on the page ships an empty alt. */
        img.setAttribute('alt', FALLBACK);
        img.setAttribute('aria-hidden', 'true');
      }
    }
  }

  var pending = false;
  var mo = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () { pending = false; label(document); }, 120);
  });

  function start() {
    label(document);
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'alt', 'class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
